import axios from "axios";
import { MessageBox, Message } from "element-ui";
import store from "@/store";
// import { getToken, setToken } from "@/utils/auth";

export const URL_ENV = {
  serverHost: "https://newsapi.ouraivision.com",
};
const service = axios.create({
  baseURL: URL_ENV.serverHost,
  timeout: 10000, // 10s
  headers: {
    "Content-Type": "application/json;charset=utf-8"
  }
});
// request interceptor
service.interceptors.request.use(
  config => {
    // 请求头携带token
    // if (getToken()) {
    //   config.headers["token"] = getToken();
    // }
    if(config.url.indexOf('get-enterprise-config') == -1) {
      config.headers["enterprise"] = store.state.mystate.enterprise
    }
    
    return config;
  },
  error => {
    // do something with request error
    console.log(error); // for debug
  }
);

// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data;
    return res;
  },
  error => {
    console.log("err" + error); // for debug
    Message({
      message: "网络不给力，请稍后再试",
      type: "error",
      duration: 3 * 1000
    });
    return Promise.reject(error);
  }
);
export default service;



// WEBPACK FOOTER //
// ./src/utils/newsRequest.js